import React, {createContext, useState, useContext, useEffect} from 'react';
import {handleLogin} from "../api/customerAPI";
import authUser from './auth';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [accessToken, setToken] = useState(null);

    useEffect(() => {
        if (accessToken) {
            localStorage.setItem('accessToken', accessToken);
        }
    }, [accessToken])

    const authenticateUser = async (initData) => {
        const {res, token} = await authUser(initData);
        if (res) {
            setToken(token);
            setIsAuthenticated(true);
        }
        return res;
    };

    const handleRootLogin = async (login, password) => {
        try {
            const {res, token} = await handleLogin(login, password);
            if (res) {
                setIsAuthenticated(true);
                setToken(token)
            }
            console.log('User authenticated:', res);
            console.log('Token:', token, 'isAuthenticated:', isAuthenticated);
            return res
        } catch (error) {
            console.error("Login error:", error);
            return false;
        }
    };

    return (
        <AuthContext.Provider value={{ accessToken, isAuthenticated, authenticateUser, handleRootLogin }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);

